import InternalFooter from './InternalFooter'

function Footer() {
    return (
        <section className='row' id='footer'>
            <div className='col-12' id='top-footer'>
                <div className='row' id='text-top'>
                    <div className='col-12 col-sm-12 col-md-6 text-center'>
                        <h2
                            data-aos="zoom-in"
                            data-aos-delay="200"><b>Gerente de Aduanas</b></h2>
                        <p
                            data-aos="zoom-in"
                            data-aos-delay="400"
                            className='text-center'>
                            Josimar Ramírez <br />
                            <i className="bi bi-telephone"></i> 55 3443 9138 <br />
                            <i className="bi bi-chat-left-dots"></i> josimar.ramirez@kj-logistics.com
                        </p>
                    </div>
                    <div className='col-12 col-sm-12 col-md-6 text-center'>
                        <h2
                            data-aos="zoom-in"
                            data-aos-delay="200"><b>Gerente de Logística</b></h2>
                        <p
                            data-aos="zoom-in"
                            data-aos-delay="400"
                            className='text-center'>
                            Claudia López<br />
                            <i className="bi bi-telephone"></i> 442 389 7588 <br />
                            <i className="bi bi-chat-left-dots"></i> claudia.lopez@kj-logistics.com
                        </p>
                    </div>
                    <div className='col-12 mt-4'
                        data-aos="zoom-in"
                        data-aos-delay="600">
                        <h3>
                            <p className='text-center'> <i className="bi bi-map"></i>
                                <br />Rio Lerma 110, Menchaca I, 76147 Querétaro
                            </p>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='col-12 p-0 m-0'>
                <InternalFooter />
            </div>

        </section>
    )
}

export default Footer
